
export const Language = {
  //login
  Msg_Register: "Let's order now",
  Msg_MobileNumber: 'Mobile number',
  Msg_EnterMobNum: 'Enter mobile number',
  Msg_Continue: 'Continue',
  Msg_InvalidNumber:
    'Mobile number must start with 6–9 and be exactly 10 digits long.',
  Msg_Error: 'Failed to send OTP. Please try again.',
  Msg_Errormob: 'Something went wrong. Please try again',
  Msg_Errorotp: 'OTP verification is failed',
  Msg_Warning: 'Please enter 6-digit MPIN.',
  Msg_Errormpin: 'MPIN and Confirm MPIN do not match.',

  //loginMPIN
  Msg_Welcome: 'Welcome',
  Msg_UserName: 'Ramesh Singh',
  Msg_Login: 'Log in with',
  Msg_MPIN: 'MPIN',
  Msg_DeviceAuth: 'Device Authentication',
  Msg_ForgetPin: 'Forgot PIN?',
  Msg_NotUser: 'Not _?',
  Msg_AddAnotherUser: 'Login with another user',
  Msg_Seerecomended: 'Recommended Products',

  //deviceauth
  Msg_SetAuth: 'Set Device Authentication',
  Msg_Skip: 'Skip',

  //search Dealer
  Msg_TrendSearch: 'Trending Search',
  Msg_SearchDealer: 'Search Dealer',
  Msg_SearchOrder: 'Search Order',
  Msg_SearchInvoice: 'Search Invoice',
  Msg_Search: 'Search',
  Msg_SelectSchemes: 'Search Schemes',
  Msg_SelectDealerToProceed: 'Select Dealer',
  Msg_SelectUnit: 'Select Unit',
  Msg_activeFocSchemes: 'Active FOC Schemes',
  Msg_activeValueSchemes: 'Active Value Schemes',
  Lbl_schemeCode: 'Scheme Code',
  //Product
  // Msg_Search: "Search Product",
  Msg_Car: 'Cars',
  Msg_Commercial: 'Commercial Vehicles',
  Msg_Energy: 'Energy',
  Msg_Industrial: 'Industrial',
  Msg_Marine: 'Marine',
  Msg_Motorcycles: 'Motorcycles',
  Msg_CarAncillaries: 'Car Ancillaries',

  Msg_BOT1: 'BOT 130M',
  Msg_Product: 'Product',
  Msg_Productpage: 'Product',

  //productView
  Msg_Plus: '+',
  Msg_Minus: '-',
  Msg_SimilarProduct: 'Similar Products',
  Msg_SeeAll: 'See all similar products',
  Msg_LandedPrice: 'Landed price/per unit',
  Msg_Total: 'Total',
  Msg_Add: 'Add',
  Msg_AddtoCart: 'Add to Cart',
  Msg_viewSelectedProducts: 'View Selected Products',
  Msg_selected: 'Selected',
  Msg_onlyOptions: 'Options',
  Msg_Save: 'Save',
  Msg_Options: '2 Options',
  Msg_Previously: 'Previously Brought',
  Msg_AddCart: 'Add to Cart',
  Msg_ProdpageDesc:
    'Explore, select, and keep your stock ready.',

  // OTP page
  Msg_Otptitle: 'Enter your OTP',
  Msg_Otpsubtitle: ' OTP sent to your registered mobile number ',
  Msg_Otpverify: 'Verify OTP',
  Msg_Otpfooter: 'Did not receive OTP yet?',

  // Modal
  Msg_ModalText: 'Log In',
  Msg_Modalsuccess: 'Successfully',
  Msg_ModalTex: 'If you are not redirected automatically, please',
  Msg_Modalclick: 'Click here',

  // SetMPIN
  Msg_SignInTitle: 'Set MPIN',
  Msg_SignInTitleChange: 'Change MPIN',
  Msg_Typemipn: 'Type MPIN',
  Msg_ReTypempin: 'Re-Type MPIN',
  Msg_Checklable: 'Capture GPS Locations',

  // Header
  Msg_Recomended: 'Recommended Products',
  Msg_Category: 'Shop By Category',

  //Tradeorder
  Msg_Tradea: 'Schemes',
  Msg_TradeSchSubTxt:
    'Track your progress made against the targets defined.',
  Msg_Order: 'Order',

  Msg_OrderDesc:
    'See your billed, unbilled, and cancelled orders easily. ',

  // Tab

  Msg_Fretab: ' Frequently Bought',
  Msg_Quitab: 'Quick Reorder',
  Msg_Trendtab: 'Stock Up Again',
  Msg_LocFav: 'Local Favorites',
  Msg_Trendarea: 'Trending in your area',
  Msg_PastPurch: 'Your past purchase picks',
  //wishlist
  Msg_NoWishItems: 'No Wishlist items found',
  //KYC
  Msg_KYCStat: 'KYC Status',
  // ordermodal
  Msg_ordermodal: 'Order Placed Successfully',
  Msg_greeting: 'Thank You',
  Msg_Modaldone: 'Done',
  Msg_OrderId: 'Order ID',
  // Transactions
  Msg_noTrans: 'No Transactions',
  Msg_Outs: 'Outstanding',
  Msg_Type: 'Type',
  //cart
  Msg_Deliver: 'Deliver to',
  Msg_Address: 'Milan Auto Store, Nashik Road, Maharashtra',
  Msg_SuggestionTitle: 'Did you forget?',
  Msg_Badge: 'Previously brought!',
  Msg_ConfirmText: 'Confirm Order',
  productListHeaderName: '',
  Msg_ShipAdd: 'Shipping Address',
  Msg_BillAdd: 'Billing Address',
  Msg_AddRem: 'Additional Remarks',
  Msg_BillDets: 'Billing details',
  Msg_SubTot: 'Sub total',
  Msg_GrTot: 'Grand total',
  Msg_CancelPol: 'Cancellation Policy',
  Msg_CartEmp: 'Your cart is empty',
  Msg_PolicyText1: 'Orders cannot be cancelled once invoiced for delivery.',
  Msg_PolicyText2:
    ' In case of unexpected delays, a refund will be provided, if applicable.',
  // order
  Msg_order: 'Your Orders',
  Msg_reorder: 'Reorder',
  Msg_Invoice: 'Invoice',
  Msg_orderSuccess: 'Order Placed Successfully',
  Msg_FulBilled: 'Fully Billed',
  Msg_ParBilled: 'Partially Billed',
  Msg_UnBilled: 'Unbilled',
  //Menu
  Msg_Home: 'Home',
  Msg_ScanBuy: 'ScanBuy',
  Msg_Orders: 'Orders',
  Msg_Products: 'Products',
  Msg_Schemes: 'Schemes',
  Msg_Profile: 'Profile',

  //Profile
  Msg_ChangeDealer: 'Change Dealer',
  Msg_ChangeDealerMessage: 'Do you want to change the dealer?',
  Msg_userName: 'Milan Auto Store',
  Msg_Favourite: 'Wishlist',
  Msg_AddressBook: 'Address Book',
  Msg_AboutUs: 'About US',
  Msg_Yourorder: 'Your Order',
  Msg_faq: 'FAQs',
  Msg_terms: 'Terms & Conditions',
  Msg_CustomerCare: 'Customer Care',
  Msg_ChangeMPIN: 'Change MPIN',
  Msg_Logout: 'Log Out',
  Msg_vwInvoices: 'Invoices',
  Msg_cart: 'Cart',
  Msg_viewCart: 'View Cart',
  Msg_Seerecommended: 'Recommended Products',
  Msg_SearchRecommended: 'Search Recommended Products',
  Msg_ResendOTP: 'Resend OTP',
  Msg_logout: 'Do you want to Log Out ?',

  //label
  Lbl_Error: 'Error',
  Lbl_OK: 'OK',
  Lbl_Success: 'Success',
  Lbl_Warning: 'Warning',
  Lbl_Cancel: 'Cancel',
  Lbl_Delink: 'Yes, Delink',
  Lbl_NoData: 'No Data Found',
  Lbl_Alert: 'Alert',
  Lbl_Yes: 'Yes',
  Lbl_No: 'No',
  Lbl_GST: 'GST',
  Lbl_IncGST: 'Incl. GST',
  lbl_viewAll: 'View All',
  lbl_viewSchemes: 'View Schemes',
  Lbl_validTill: 'Valid Till',
  Lbl_focVolume: 'Achieved',
  lbl_hotSchemePicks: 'Top Schemes for you',
  Msg_hotSchemeSub: 'Best schemes for you. Save more with every order.',

  Msg_SearchTransaction: 'Search Transaction',
  Msg_Transactions: 'Transactions',
  Msg_NetConn: 'Network Connectivity',
  Msg_NoInternet: 'No Internet Connection..!!',
  Msg_Transpage: 'Transactions',
  Msg_transDesc:
    'Monitor your transactions and keep track your progress',
  //Category
  Msg_ViewAll: 'VIEW ALL',
  Msg_Items: 'Items',
  Msg_Item: 'Item',
  Lbl_OrderDisc: 'Order Total Value is an estimate. Final invoice is subject to pricing, discount, and surcharge adjustments.',
  //schemes
  Msg_totalEstimatedPayout: 'Total Expected Payout',
  Msg_totalFoc: 'Total FOC Achieved',
  Msg_total: 'FOC Achieved',
  Lbl_daysLeft: 'Days left',
  Lbl_StDate: 'Start Date',
  Lbl_EndDate: 'End Date',
  Msg_Estimated_Payment: 'Expected Payout',

  Msg_morePayout: ' Buy _ LT more to achieve the payout',
  Msg_moreReward: 'Buy _ LT more to get reward',
  Msg_recomendedProducts: 'See Recommended Products',
  Msg_benefits: 'Benefits Earned',
  Msg_foc: 'FOC Earned',
  lbl_saved: 'Saved ',
  lbl_suggested: 'Suggested',
  lbl_searchBenifit: 'Search Benifits Earned',
  lbl_searchFOC: 'Search FOC Earned',
  lbl_searchTrans: 'Search Transactions',
  Msg_recmmschemes: 'All Recommended Schemes',
  lbl_recommendedProds: 'Search Recommended Products',
  lbl_seeAllSchemes: 'See All Schemes',
  lbl_search: 'Search',

  lbl_shareVia: 'Share Via',
  lbl_docNo: 'INV No',
  lbl_Date: 'Date',
  lbl_Scheme_Code: 'Scheme Code',
  lbl_CN_No: 'CN No.',
  lbl_Amount: 'Amount',
  lbl_Off: 'OFF',
  lbl_lt: 'Litre',
  lbl_FOC_Payout: 'FOC Payout',
  lbl_Value_Payout: 'Value Payout',
  lbl_applicable_products: 'All Applicable Products',
  lbl_rupees_sign: '₹',
  lbl_Pack: 'Pack',
  lbl_L: 'L',
  lbl_Ltr: ' Ltr',
  Msg_NoRecords: 'No Records',
  Msg_Volume: 'Volume',
};
